import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getSoloMioConfig = (t: TranslateFunction): GiveawayConfig => {
  return createBaseConfig({
    theatricalSlug: slugs.soloMio,
    heroTitle: t('win7DayItalianGetaway', 'Win a 7-Day Italian Getaway for 2'),
    logoUrl: angelImagesUrl('v1769018020/solo%20mio/solo-mio-logo-gold-and-white'),
    inTheatersText: t('inTheatersSoloMio', 'In theaters February 6, 2026'),
    videoImage: angelImagesUrl('v1768499043/solo%20mio/details-video-thumbnail-no-play-button'),
    releaseDate: 'February 6, 2026',
    backgroundVideoUrl:
      'https://images.angelstudios.com/video/upload/v1770139862/solo%20mio/solo-mio_tLoopingVideo_NewTrailer_wNOCAPS_16x9_f23_y20260203_iTD-lowres.mp4',

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.soloMio,
      congratsKey: 'soloMioCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the Solo Mio Lovers Getaway! Complete your checkout to secure your entries.",
      // TODO: Add portrait image
      portraitImage: staticAssetUrl('v1763825328/solo%20mio/social-modal-desktop'),
      reservationKey: 'soloMioReservationCompleteText',
      reservationText: "You've earned entries for your chance to win the Solo Mio Lovers Getaway!",
      noShowtimesKey: 'soloMioNoShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, preorder tickets today for your chance to win the Solo Mio Lovers Getaway!",
      // TODO: Add landscape image
      landscapeImage: staticAssetUrl('v1763825333/solo%20mio/social-modal-mobile'),
    }),

    steps: [
      {
        title: t('preOrderTicketsV2', 'Preorder Tickets'),
        description: t('soloMioChooseYourTickets', 'Choose your tickets to Solo Mio below.'),
      },
      {
        title: t('receiveYourPromoCodes', 'Receive Your Promo Codes'),
        description: t(
          'eachTicketEarnsAPromoCode',
          'Each ticket earns you a unique promo code (redeemable when showtimes are available).',
        ),
      },
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'theMoreTicketsYouBuy',
          'The more tickets you buy, and the earlier you buy them, the greater your entry multiplier, boosting your odds of winning!',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [],
    partnerLogos: [],
  })
}
